<div class="application-alert">Sites alerts</div>
<div class="application-alert-container">
  <div class="alert-container" [ngClass]="{ checkedClass: !showSiteAddList, unCheckedClass: showSiteAddList }">
    <div class="all-application">
      <div class="radio-button">
        <mat-radio-button color="primary" name="sites" value="sites" [checked]="defaultSiteChecked"
          (change)="changeApplication($event)">All Sites</mat-radio-button>
      </div>
    </div>
    <div class="minimum-severity">
      <div class="minimum-severity-text">Minimum severity</div>
      <div class="apllication-text">
        <mat-select class="text custom-select" [disabled]="showSiteAddList" name="siteMinimumSeverity"
          [value]="siteMinimumSeverity" (selectionChange)="minimumSeverityChange($event, 'allSite')"
          [ngClass]="{ 'disable-custom-select': showSiteAddList }" name="digestEmailTimeSelected">
          <mat-option *ngFor="let option of minimumSeverity" [value]="option">
            {{ option }}
          </mat-option>
        </mat-select>
      </div>
    </div>
  </div>
</div>

<div class="custom-application-container"
  [ngClass]="{ checkedClass: showSiteAddList, unCheckedClass: !showSiteAddList }">
  <div class="custom-application-configuration">
    <div class="custum-radio">
      <mat-radio-button color="primary" name="sites" value="custom-sites" [checked]="!defaultSiteChecked"
        (change)="changeApplication($event)"></mat-radio-button>
    </div>
    <div class="configuration-text">
      <div class="configuration-text">Custom sites configuration</div>
      <div class="sub-text">Receive emails for these sites only</div>
    </div>
  </div>
  <div class="table-container" *ngIf="showSiteAddList">
    <mat-table [dataSource]="selectedSiteList" *ngIf="selectedSiteList.data.length">
      <ng-container matColumnDef="sites">
        <th mat-header-cell *matHeaderCellDef>Sites</th>
        <td mat-cell *matCellDef="let element">
          {{ element.name }}
        </td>
      </ng-container>

      <ng-container matColumnDef="minimumseverity">
        <th mat-header-cell *matHeaderCellDef>Minimum severity</th>

        <td mat-cell *matCellDef="let element">
          <mat-select class="text custom-select" name="customsiteMinimumSeverity" [value]="element.minimumSeverity"
            (selectionChange)="minimumSeverityChange($event, 'customSiteSeverity', element)">
            <mat-option *ngFor="let option of minimumSeverity" [value]="option">
              {{ option }}
            </mat-option>
          </mat-select>
        </td>
      </ng-container>

      <ng-container matColumnDef="remove">
        <th mat-header-cell *matHeaderCellDef>Remove</th>
        <td mat-cell *matCellDef="let row">
          <mat-icon class="remove-icon" (click)="removeSite(row)">clear</mat-icon>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="sitesdisplayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: sitesdisplayedColumns"></tr>
    </mat-table>
    <div class="add-list">
      <mat-icon class="add-icon" (click)="openSiteSelectionWizard('user_site_selection')">add_box</mat-icon>
      <span>Add site alert</span>
    </div>
  </div>
  <nrwl-paginator #paginator [totalResult]="selectedSiteList.data.length" (nextPage)="nextPage($event)">
  </nrwl-paginator>
</div>